import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ThirdPartyDevicesQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ThirdPartyDevicesQuery = { __typename?: 'Query', thirdPartyDevices?: Array<{ __typename?: 'ThirdPartyDevice', id: number, description?: string | null, registrationTime?: any | null, registrationExpireTime?: any | null, clientInfo?: string | null, sipUser: string, sipPassword: string } | null> | null };

export type LinkedDevicesQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type LinkedDevicesQuery = { __typename?: 'Query', linkedDevices?: Array<{ __typename?: 'LinkedDevice', id: number, name: string, macAddress: string } | null> | null };

export type SipUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SipUserQuery = { __typename?: 'Query', sipUser?: { __typename?: 'SIPUser', username: string, password: string } | null };

export type ClientDevicesQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ClientDevicesQuery = { __typename?: 'Query', clientDevices: Array<{ __typename?: 'ClientDevice', id: number, type: string, description?: string | null, registrationTime?: any | null, registrationExpireTime?: any | null, clientInfo?: string | null, sipPassword: string, sipUser: string }> };

export type ProvisionedDevicesQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ProvisionedDevicesQuery = { __typename?: 'Query', provisionedDevices?: Array<{ __typename?: 'ProvisionedDevice', id: number, macAddress?: string | null, variant?: string | null, registrationTime?: any | null, registrationExpireTime?: any | null, sipPassword: string, sipUser: string, clientInfo?: string | null, provisioning: boolean, useDisplayNameForStationName: boolean, vendor: { __typename?: 'Vendor', id: number, name: string } } | null> | null };

export type DeviceLimitQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type DeviceLimitQuery = { __typename?: 'Query', deviceLimit: Array<{ __typename?: 'DeviceSetLimit', devices: Array<string>, limit?: number | null }> };

export type SaveThirdPartyDeviceMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  description: Types.Scalars['String']['input'];
  sipUser: Types.Scalars['String']['input'];
  sipPassword: Types.Scalars['String']['input'];
}>;


export type SaveThirdPartyDeviceMutation = { __typename?: 'Mutation', saveThirdPartyDevice?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };

export type SaveClientDeviceMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  clientType?: Types.InputMaybe<Types.ClientType>;
  description: Types.Scalars['String']['input'];
}>;


export type SaveClientDeviceMutation = { __typename?: 'Mutation', saveClientDevice?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };

export type SavePhoneButtonsMutationVariables = Types.Exact<{
  provisionedDeviceId: Types.Scalars['Int']['input'];
  buttons: Array<Types.PhoneButtonInput>;
}>;


export type SavePhoneButtonsMutation = { __typename?: 'Mutation', savePhoneButtons: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };

export type TargetNumbersQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  notUser?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type TargetNumbersQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };

export type ButtonsFormDataQueryVariables = Types.Exact<{
  provisionedDeviceId: Types.Scalars['Int']['input'];
}>;


export type ButtonsFormDataQuery = { __typename?: 'Query', phoneButtons?: Array<{ __typename?: 'PhoneButton', buttonType: Types.PhoneButtonType, buttonPosition: number, targetNumberId?: number | null, speedDialNumber?: string | null, display?: string | null } | null> | null };

export type SaveProvisionedDeviceMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  macAddress: Types.Scalars['String']['input'];
  vendorId: Types.Scalars['Int']['input'];
  variant: Types.Scalars['String']['input'];
  provisioning: Types.Scalars['Boolean']['input'];
  useDisplayNameForStationName: Types.Scalars['Boolean']['input'];
}>;


export type SaveProvisionedDeviceMutation = { __typename?: 'Mutation', saveProvisionedDevice?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };

export type DeleteThirdPartyDeviceMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteThirdPartyDeviceMutation = { __typename?: 'Mutation', deleteThirdPartyDevice?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null } | null> | null };

export type DeleteClientDeviceMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteClientDeviceMutation = { __typename?: 'Mutation', deleteClientDevice?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null } | null> | null };

export type DeleteProvisionedDeviceMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteProvisionedDeviceMutation = { __typename?: 'Mutation', deleteProvisionedDevice?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null } | null> | null };

export type DeleteLinkedDeviceMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteLinkedDeviceMutation = { __typename?: 'Mutation', deleteLinkedDevice?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null } | null> | null };

export type DeviceVariantsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DeviceVariantsQuery = { __typename?: 'Query', deviceVariants?: { __typename?: 'DeviceVariantList', items: Array<{ __typename?: 'DeviceVariant', id: number, name: string, domain?: { __typename?: 'Domain', id: number } | null } | null> } | null };

export type DomainIdViaExtensionQueryVariables = Types.Exact<{
  extensionId: Types.Scalars['Int']['input'];
}>;


export type DomainIdViaExtensionQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', number?: { __typename?: 'Number', domainId: number } | null } | null> } | null };


export const ThirdPartyDevicesDocument = gql`
    query ThirdPartyDevices($userId: Int!) {
  thirdPartyDevices(userId: $userId) {
    id
    description
    registrationTime
    registrationExpireTime
    clientInfo
    sipUser
    sipPassword
  }
}
    `;

/**
 * __useThirdPartyDevicesQuery__
 *
 * To run a query within a React component, call `useThirdPartyDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyDevicesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useThirdPartyDevicesQuery(baseOptions: Apollo.QueryHookOptions<ThirdPartyDevicesQuery, ThirdPartyDevicesQueryVariables> & ({ variables: ThirdPartyDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThirdPartyDevicesQuery, ThirdPartyDevicesQueryVariables>(ThirdPartyDevicesDocument, options);
      }
export function useThirdPartyDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyDevicesQuery, ThirdPartyDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThirdPartyDevicesQuery, ThirdPartyDevicesQueryVariables>(ThirdPartyDevicesDocument, options);
        }
export function useThirdPartyDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThirdPartyDevicesQuery, ThirdPartyDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThirdPartyDevicesQuery, ThirdPartyDevicesQueryVariables>(ThirdPartyDevicesDocument, options);
        }
export type ThirdPartyDevicesQueryHookResult = ReturnType<typeof useThirdPartyDevicesQuery>;
export type ThirdPartyDevicesLazyQueryHookResult = ReturnType<typeof useThirdPartyDevicesLazyQuery>;
export type ThirdPartyDevicesSuspenseQueryHookResult = ReturnType<typeof useThirdPartyDevicesSuspenseQuery>;
export type ThirdPartyDevicesQueryResult = Apollo.QueryResult<ThirdPartyDevicesQuery, ThirdPartyDevicesQueryVariables>;
export const LinkedDevicesDocument = gql`
    query LinkedDevices($userId: Int!) {
  linkedDevices(userId: $userId) {
    id
    name
    macAddress
  }
}
    `;

/**
 * __useLinkedDevicesQuery__
 *
 * To run a query within a React component, call `useLinkedDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedDevicesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLinkedDevicesQuery(baseOptions: Apollo.QueryHookOptions<LinkedDevicesQuery, LinkedDevicesQueryVariables> & ({ variables: LinkedDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedDevicesQuery, LinkedDevicesQueryVariables>(LinkedDevicesDocument, options);
      }
export function useLinkedDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedDevicesQuery, LinkedDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedDevicesQuery, LinkedDevicesQueryVariables>(LinkedDevicesDocument, options);
        }
export function useLinkedDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkedDevicesQuery, LinkedDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkedDevicesQuery, LinkedDevicesQueryVariables>(LinkedDevicesDocument, options);
        }
export type LinkedDevicesQueryHookResult = ReturnType<typeof useLinkedDevicesQuery>;
export type LinkedDevicesLazyQueryHookResult = ReturnType<typeof useLinkedDevicesLazyQuery>;
export type LinkedDevicesSuspenseQueryHookResult = ReturnType<typeof useLinkedDevicesSuspenseQuery>;
export type LinkedDevicesQueryResult = Apollo.QueryResult<LinkedDevicesQuery, LinkedDevicesQueryVariables>;
export const SipUserDocument = gql`
    query SipUser {
  sipUser {
    username
    password
  }
}
    `;

/**
 * __useSipUserQuery__
 *
 * To run a query within a React component, call `useSipUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSipUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSipUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSipUserQuery(baseOptions?: Apollo.QueryHookOptions<SipUserQuery, SipUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SipUserQuery, SipUserQueryVariables>(SipUserDocument, options);
      }
export function useSipUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SipUserQuery, SipUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SipUserQuery, SipUserQueryVariables>(SipUserDocument, options);
        }
export function useSipUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SipUserQuery, SipUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SipUserQuery, SipUserQueryVariables>(SipUserDocument, options);
        }
export type SipUserQueryHookResult = ReturnType<typeof useSipUserQuery>;
export type SipUserLazyQueryHookResult = ReturnType<typeof useSipUserLazyQuery>;
export type SipUserSuspenseQueryHookResult = ReturnType<typeof useSipUserSuspenseQuery>;
export type SipUserQueryResult = Apollo.QueryResult<SipUserQuery, SipUserQueryVariables>;
export const ClientDevicesDocument = gql`
    query ClientDevices($userId: Int!) {
  clientDevices(userId: $userId) {
    id
    type
    description
    registrationTime
    registrationExpireTime
    clientInfo
    sipPassword
    sipUser
  }
}
    `;

/**
 * __useClientDevicesQuery__
 *
 * To run a query within a React component, call `useClientDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDevicesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClientDevicesQuery(baseOptions: Apollo.QueryHookOptions<ClientDevicesQuery, ClientDevicesQueryVariables> & ({ variables: ClientDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientDevicesQuery, ClientDevicesQueryVariables>(ClientDevicesDocument, options);
      }
export function useClientDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientDevicesQuery, ClientDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientDevicesQuery, ClientDevicesQueryVariables>(ClientDevicesDocument, options);
        }
export function useClientDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientDevicesQuery, ClientDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientDevicesQuery, ClientDevicesQueryVariables>(ClientDevicesDocument, options);
        }
export type ClientDevicesQueryHookResult = ReturnType<typeof useClientDevicesQuery>;
export type ClientDevicesLazyQueryHookResult = ReturnType<typeof useClientDevicesLazyQuery>;
export type ClientDevicesSuspenseQueryHookResult = ReturnType<typeof useClientDevicesSuspenseQuery>;
export type ClientDevicesQueryResult = Apollo.QueryResult<ClientDevicesQuery, ClientDevicesQueryVariables>;
export const ProvisionedDevicesDocument = gql`
    query ProvisionedDevices($userId: Int!) {
  provisionedDevices(userId: $userId) {
    id
    macAddress
    variant
    registrationTime
    registrationExpireTime
    sipPassword
    sipUser
    clientInfo
    provisioning
    useDisplayNameForStationName
    vendor {
      id
      name
    }
  }
}
    `;

/**
 * __useProvisionedDevicesQuery__
 *
 * To run a query within a React component, call `useProvisionedDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvisionedDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvisionedDevicesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProvisionedDevicesQuery(baseOptions: Apollo.QueryHookOptions<ProvisionedDevicesQuery, ProvisionedDevicesQueryVariables> & ({ variables: ProvisionedDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvisionedDevicesQuery, ProvisionedDevicesQueryVariables>(ProvisionedDevicesDocument, options);
      }
export function useProvisionedDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvisionedDevicesQuery, ProvisionedDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvisionedDevicesQuery, ProvisionedDevicesQueryVariables>(ProvisionedDevicesDocument, options);
        }
export function useProvisionedDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProvisionedDevicesQuery, ProvisionedDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvisionedDevicesQuery, ProvisionedDevicesQueryVariables>(ProvisionedDevicesDocument, options);
        }
export type ProvisionedDevicesQueryHookResult = ReturnType<typeof useProvisionedDevicesQuery>;
export type ProvisionedDevicesLazyQueryHookResult = ReturnType<typeof useProvisionedDevicesLazyQuery>;
export type ProvisionedDevicesSuspenseQueryHookResult = ReturnType<typeof useProvisionedDevicesSuspenseQuery>;
export type ProvisionedDevicesQueryResult = Apollo.QueryResult<ProvisionedDevicesQuery, ProvisionedDevicesQueryVariables>;
export const DeviceLimitDocument = gql`
    query DeviceLimit($userId: Int!) {
  deviceLimit(userId: $userId) {
    devices
    limit
  }
}
    `;

/**
 * __useDeviceLimitQuery__
 *
 * To run a query within a React component, call `useDeviceLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceLimitQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeviceLimitQuery(baseOptions: Apollo.QueryHookOptions<DeviceLimitQuery, DeviceLimitQueryVariables> & ({ variables: DeviceLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceLimitQuery, DeviceLimitQueryVariables>(DeviceLimitDocument, options);
      }
export function useDeviceLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceLimitQuery, DeviceLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceLimitQuery, DeviceLimitQueryVariables>(DeviceLimitDocument, options);
        }
export function useDeviceLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceLimitQuery, DeviceLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceLimitQuery, DeviceLimitQueryVariables>(DeviceLimitDocument, options);
        }
export type DeviceLimitQueryHookResult = ReturnType<typeof useDeviceLimitQuery>;
export type DeviceLimitLazyQueryHookResult = ReturnType<typeof useDeviceLimitLazyQuery>;
export type DeviceLimitSuspenseQueryHookResult = ReturnType<typeof useDeviceLimitSuspenseQuery>;
export type DeviceLimitQueryResult = Apollo.QueryResult<DeviceLimitQuery, DeviceLimitQueryVariables>;
export const SaveThirdPartyDeviceDocument = gql`
    mutation SaveThirdPartyDevice($id: Int, $userId: Int, $description: String!, $sipUser: String!, $sipPassword: String!) {
  saveThirdPartyDevice(
    id: $id
    userId: $userId
    description: $description
    sipUser: $sipUser
    sipPassword: $sipPassword
  ) {
    id
    errors {
      location
      type
      context
    }
  }
}
    `;
export type SaveThirdPartyDeviceMutationFn = Apollo.MutationFunction<SaveThirdPartyDeviceMutation, SaveThirdPartyDeviceMutationVariables>;

/**
 * __useSaveThirdPartyDeviceMutation__
 *
 * To run a mutation, you first call `useSaveThirdPartyDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveThirdPartyDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveThirdPartyDeviceMutation, { data, loading, error }] = useSaveThirdPartyDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      description: // value for 'description'
 *      sipUser: // value for 'sipUser'
 *      sipPassword: // value for 'sipPassword'
 *   },
 * });
 */
export function useSaveThirdPartyDeviceMutation(baseOptions?: Apollo.MutationHookOptions<SaveThirdPartyDeviceMutation, SaveThirdPartyDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveThirdPartyDeviceMutation, SaveThirdPartyDeviceMutationVariables>(SaveThirdPartyDeviceDocument, options);
      }
export type SaveThirdPartyDeviceMutationHookResult = ReturnType<typeof useSaveThirdPartyDeviceMutation>;
export type SaveThirdPartyDeviceMutationResult = Apollo.MutationResult<SaveThirdPartyDeviceMutation>;
export type SaveThirdPartyDeviceMutationOptions = Apollo.BaseMutationOptions<SaveThirdPartyDeviceMutation, SaveThirdPartyDeviceMutationVariables>;
export const SaveClientDeviceDocument = gql`
    mutation SaveClientDevice($id: Int, $userId: Int, $clientType: ClientType, $description: String!) {
  saveClientDevice(
    id: $id
    userId: $userId
    clientType: $clientType
    description: $description
  ) {
    id
    errors {
      location
      type
      context
    }
  }
}
    `;
export type SaveClientDeviceMutationFn = Apollo.MutationFunction<SaveClientDeviceMutation, SaveClientDeviceMutationVariables>;

/**
 * __useSaveClientDeviceMutation__
 *
 * To run a mutation, you first call `useSaveClientDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientDeviceMutation, { data, loading, error }] = useSaveClientDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      clientType: // value for 'clientType'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSaveClientDeviceMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientDeviceMutation, SaveClientDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientDeviceMutation, SaveClientDeviceMutationVariables>(SaveClientDeviceDocument, options);
      }
export type SaveClientDeviceMutationHookResult = ReturnType<typeof useSaveClientDeviceMutation>;
export type SaveClientDeviceMutationResult = Apollo.MutationResult<SaveClientDeviceMutation>;
export type SaveClientDeviceMutationOptions = Apollo.BaseMutationOptions<SaveClientDeviceMutation, SaveClientDeviceMutationVariables>;
export const SavePhoneButtonsDocument = gql`
    mutation SavePhoneButtons($provisionedDeviceId: Int!, $buttons: [PhoneButtonInput!]!) {
  savePhoneButtons(provisionedDeviceId: $provisionedDeviceId, buttons: $buttons) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type SavePhoneButtonsMutationFn = Apollo.MutationFunction<SavePhoneButtonsMutation, SavePhoneButtonsMutationVariables>;

/**
 * __useSavePhoneButtonsMutation__
 *
 * To run a mutation, you first call `useSavePhoneButtonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePhoneButtonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePhoneButtonsMutation, { data, loading, error }] = useSavePhoneButtonsMutation({
 *   variables: {
 *      provisionedDeviceId: // value for 'provisionedDeviceId'
 *      buttons: // value for 'buttons'
 *   },
 * });
 */
export function useSavePhoneButtonsMutation(baseOptions?: Apollo.MutationHookOptions<SavePhoneButtonsMutation, SavePhoneButtonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePhoneButtonsMutation, SavePhoneButtonsMutationVariables>(SavePhoneButtonsDocument, options);
      }
export type SavePhoneButtonsMutationHookResult = ReturnType<typeof useSavePhoneButtonsMutation>;
export type SavePhoneButtonsMutationResult = Apollo.MutationResult<SavePhoneButtonsMutation>;
export type SavePhoneButtonsMutationOptions = Apollo.BaseMutationOptions<SavePhoneButtonsMutation, SavePhoneButtonsMutationVariables>;
export const TargetNumbersDocument = gql`
    query TargetNumbers($domainId: Int!, $notUser: Int) {
  users(domainId: $domainId, notId: $notUser) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useTargetNumbersQuery__
 *
 * To run a query within a React component, call `useTargetNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetNumbersQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      notUser: // value for 'notUser'
 *   },
 * });
 */
export function useTargetNumbersQuery(baseOptions: Apollo.QueryHookOptions<TargetNumbersQuery, TargetNumbersQueryVariables> & ({ variables: TargetNumbersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetNumbersQuery, TargetNumbersQueryVariables>(TargetNumbersDocument, options);
      }
export function useTargetNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetNumbersQuery, TargetNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetNumbersQuery, TargetNumbersQueryVariables>(TargetNumbersDocument, options);
        }
export function useTargetNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetNumbersQuery, TargetNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetNumbersQuery, TargetNumbersQueryVariables>(TargetNumbersDocument, options);
        }
export type TargetNumbersQueryHookResult = ReturnType<typeof useTargetNumbersQuery>;
export type TargetNumbersLazyQueryHookResult = ReturnType<typeof useTargetNumbersLazyQuery>;
export type TargetNumbersSuspenseQueryHookResult = ReturnType<typeof useTargetNumbersSuspenseQuery>;
export type TargetNumbersQueryResult = Apollo.QueryResult<TargetNumbersQuery, TargetNumbersQueryVariables>;
export const ButtonsFormDataDocument = gql`
    query ButtonsFormData($provisionedDeviceId: Int!) {
  phoneButtons(provisionedDeviceId: $provisionedDeviceId) {
    buttonType
    buttonPosition
    targetNumberId
    speedDialNumber
    display
  }
}
    `;

/**
 * __useButtonsFormDataQuery__
 *
 * To run a query within a React component, call `useButtonsFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useButtonsFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useButtonsFormDataQuery({
 *   variables: {
 *      provisionedDeviceId: // value for 'provisionedDeviceId'
 *   },
 * });
 */
export function useButtonsFormDataQuery(baseOptions: Apollo.QueryHookOptions<ButtonsFormDataQuery, ButtonsFormDataQueryVariables> & ({ variables: ButtonsFormDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ButtonsFormDataQuery, ButtonsFormDataQueryVariables>(ButtonsFormDataDocument, options);
      }
export function useButtonsFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ButtonsFormDataQuery, ButtonsFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ButtonsFormDataQuery, ButtonsFormDataQueryVariables>(ButtonsFormDataDocument, options);
        }
export function useButtonsFormDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ButtonsFormDataQuery, ButtonsFormDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ButtonsFormDataQuery, ButtonsFormDataQueryVariables>(ButtonsFormDataDocument, options);
        }
export type ButtonsFormDataQueryHookResult = ReturnType<typeof useButtonsFormDataQuery>;
export type ButtonsFormDataLazyQueryHookResult = ReturnType<typeof useButtonsFormDataLazyQuery>;
export type ButtonsFormDataSuspenseQueryHookResult = ReturnType<typeof useButtonsFormDataSuspenseQuery>;
export type ButtonsFormDataQueryResult = Apollo.QueryResult<ButtonsFormDataQuery, ButtonsFormDataQueryVariables>;
export const SaveProvisionedDeviceDocument = gql`
    mutation SaveProvisionedDevice($id: Int, $userId: Int, $macAddress: String!, $vendorId: Int!, $variant: String!, $provisioning: Boolean!, $useDisplayNameForStationName: Boolean!) {
  saveProvisionedDevice(
    id: $id
    userId: $userId
    macAddress: $macAddress
    vendorId: $vendorId
    variant: $variant
    provisioning: $provisioning
    useDisplayNameForStationName: $useDisplayNameForStationName
  ) {
    id
    errors {
      location
      type
      context
    }
  }
}
    `;
export type SaveProvisionedDeviceMutationFn = Apollo.MutationFunction<SaveProvisionedDeviceMutation, SaveProvisionedDeviceMutationVariables>;

/**
 * __useSaveProvisionedDeviceMutation__
 *
 * To run a mutation, you first call `useSaveProvisionedDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProvisionedDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProvisionedDeviceMutation, { data, loading, error }] = useSaveProvisionedDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      macAddress: // value for 'macAddress'
 *      vendorId: // value for 'vendorId'
 *      variant: // value for 'variant'
 *      provisioning: // value for 'provisioning'
 *      useDisplayNameForStationName: // value for 'useDisplayNameForStationName'
 *   },
 * });
 */
export function useSaveProvisionedDeviceMutation(baseOptions?: Apollo.MutationHookOptions<SaveProvisionedDeviceMutation, SaveProvisionedDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProvisionedDeviceMutation, SaveProvisionedDeviceMutationVariables>(SaveProvisionedDeviceDocument, options);
      }
export type SaveProvisionedDeviceMutationHookResult = ReturnType<typeof useSaveProvisionedDeviceMutation>;
export type SaveProvisionedDeviceMutationResult = Apollo.MutationResult<SaveProvisionedDeviceMutation>;
export type SaveProvisionedDeviceMutationOptions = Apollo.BaseMutationOptions<SaveProvisionedDeviceMutation, SaveProvisionedDeviceMutationVariables>;
export const DeleteThirdPartyDeviceDocument = gql`
    mutation DeleteThirdPartyDevice($id: Int!) {
  deleteThirdPartyDevice(id: $id) {
    location
    type
    context
  }
}
    `;
export type DeleteThirdPartyDeviceMutationFn = Apollo.MutationFunction<DeleteThirdPartyDeviceMutation, DeleteThirdPartyDeviceMutationVariables>;

/**
 * __useDeleteThirdPartyDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteThirdPartyDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThirdPartyDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThirdPartyDeviceMutation, { data, loading, error }] = useDeleteThirdPartyDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteThirdPartyDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThirdPartyDeviceMutation, DeleteThirdPartyDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThirdPartyDeviceMutation, DeleteThirdPartyDeviceMutationVariables>(DeleteThirdPartyDeviceDocument, options);
      }
export type DeleteThirdPartyDeviceMutationHookResult = ReturnType<typeof useDeleteThirdPartyDeviceMutation>;
export type DeleteThirdPartyDeviceMutationResult = Apollo.MutationResult<DeleteThirdPartyDeviceMutation>;
export type DeleteThirdPartyDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteThirdPartyDeviceMutation, DeleteThirdPartyDeviceMutationVariables>;
export const DeleteClientDeviceDocument = gql`
    mutation DeleteClientDevice($id: Int!) {
  deleteClientDevice(id: $id) {
    location
    type
    context
  }
}
    `;
export type DeleteClientDeviceMutationFn = Apollo.MutationFunction<DeleteClientDeviceMutation, DeleteClientDeviceMutationVariables>;

/**
 * __useDeleteClientDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteClientDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientDeviceMutation, { data, loading, error }] = useDeleteClientDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientDeviceMutation, DeleteClientDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientDeviceMutation, DeleteClientDeviceMutationVariables>(DeleteClientDeviceDocument, options);
      }
export type DeleteClientDeviceMutationHookResult = ReturnType<typeof useDeleteClientDeviceMutation>;
export type DeleteClientDeviceMutationResult = Apollo.MutationResult<DeleteClientDeviceMutation>;
export type DeleteClientDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteClientDeviceMutation, DeleteClientDeviceMutationVariables>;
export const DeleteProvisionedDeviceDocument = gql`
    mutation DeleteProvisionedDevice($id: Int!) {
  deleteProvisionedDevice(id: $id) {
    location
    type
    context
  }
}
    `;
export type DeleteProvisionedDeviceMutationFn = Apollo.MutationFunction<DeleteProvisionedDeviceMutation, DeleteProvisionedDeviceMutationVariables>;

/**
 * __useDeleteProvisionedDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteProvisionedDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProvisionedDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProvisionedDeviceMutation, { data, loading, error }] = useDeleteProvisionedDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProvisionedDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProvisionedDeviceMutation, DeleteProvisionedDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProvisionedDeviceMutation, DeleteProvisionedDeviceMutationVariables>(DeleteProvisionedDeviceDocument, options);
      }
export type DeleteProvisionedDeviceMutationHookResult = ReturnType<typeof useDeleteProvisionedDeviceMutation>;
export type DeleteProvisionedDeviceMutationResult = Apollo.MutationResult<DeleteProvisionedDeviceMutation>;
export type DeleteProvisionedDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteProvisionedDeviceMutation, DeleteProvisionedDeviceMutationVariables>;
export const DeleteLinkedDeviceDocument = gql`
    mutation DeleteLinkedDevice($id: Int!) {
  deleteLinkedDevice(id: $id) {
    location
    type
    context
  }
}
    `;
export type DeleteLinkedDeviceMutationFn = Apollo.MutationFunction<DeleteLinkedDeviceMutation, DeleteLinkedDeviceMutationVariables>;

/**
 * __useDeleteLinkedDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteLinkedDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkedDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLinkedDeviceMutation, { data, loading, error }] = useDeleteLinkedDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLinkedDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLinkedDeviceMutation, DeleteLinkedDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLinkedDeviceMutation, DeleteLinkedDeviceMutationVariables>(DeleteLinkedDeviceDocument, options);
      }
export type DeleteLinkedDeviceMutationHookResult = ReturnType<typeof useDeleteLinkedDeviceMutation>;
export type DeleteLinkedDeviceMutationResult = Apollo.MutationResult<DeleteLinkedDeviceMutation>;
export type DeleteLinkedDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteLinkedDeviceMutation, DeleteLinkedDeviceMutationVariables>;
export const DeviceVariantsDocument = gql`
    query DeviceVariants($domainId: Int!) {
  deviceVariants(domainIdOrNone: $domainId) {
    items {
      id
      name
      domain {
        id
      }
    }
  }
}
    `;

/**
 * __useDeviceVariantsQuery__
 *
 * To run a query within a React component, call `useDeviceVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceVariantsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDeviceVariantsQuery(baseOptions: Apollo.QueryHookOptions<DeviceVariantsQuery, DeviceVariantsQueryVariables> & ({ variables: DeviceVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceVariantsQuery, DeviceVariantsQueryVariables>(DeviceVariantsDocument, options);
      }
export function useDeviceVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceVariantsQuery, DeviceVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceVariantsQuery, DeviceVariantsQueryVariables>(DeviceVariantsDocument, options);
        }
export function useDeviceVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceVariantsQuery, DeviceVariantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceVariantsQuery, DeviceVariantsQueryVariables>(DeviceVariantsDocument, options);
        }
export type DeviceVariantsQueryHookResult = ReturnType<typeof useDeviceVariantsQuery>;
export type DeviceVariantsLazyQueryHookResult = ReturnType<typeof useDeviceVariantsLazyQuery>;
export type DeviceVariantsSuspenseQueryHookResult = ReturnType<typeof useDeviceVariantsSuspenseQuery>;
export type DeviceVariantsQueryResult = Apollo.QueryResult<DeviceVariantsQuery, DeviceVariantsQueryVariables>;
export const DomainIdViaExtensionDocument = gql`
    query DomainIdViaExtension($extensionId: Int!) {
  users(id: $extensionId) {
    items {
      number {
        domainId
      }
    }
  }
}
    `;

/**
 * __useDomainIdViaExtensionQuery__
 *
 * To run a query within a React component, call `useDomainIdViaExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainIdViaExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainIdViaExtensionQuery({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function useDomainIdViaExtensionQuery(baseOptions: Apollo.QueryHookOptions<DomainIdViaExtensionQuery, DomainIdViaExtensionQueryVariables> & ({ variables: DomainIdViaExtensionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainIdViaExtensionQuery, DomainIdViaExtensionQueryVariables>(DomainIdViaExtensionDocument, options);
      }
export function useDomainIdViaExtensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainIdViaExtensionQuery, DomainIdViaExtensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainIdViaExtensionQuery, DomainIdViaExtensionQueryVariables>(DomainIdViaExtensionDocument, options);
        }
export function useDomainIdViaExtensionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainIdViaExtensionQuery, DomainIdViaExtensionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainIdViaExtensionQuery, DomainIdViaExtensionQueryVariables>(DomainIdViaExtensionDocument, options);
        }
export type DomainIdViaExtensionQueryHookResult = ReturnType<typeof useDomainIdViaExtensionQuery>;
export type DomainIdViaExtensionLazyQueryHookResult = ReturnType<typeof useDomainIdViaExtensionLazyQuery>;
export type DomainIdViaExtensionSuspenseQueryHookResult = ReturnType<typeof useDomainIdViaExtensionSuspenseQuery>;
export type DomainIdViaExtensionQueryResult = Apollo.QueryResult<DomainIdViaExtensionQuery, DomainIdViaExtensionQueryVariables>;